import { getExternalId } from '@/lib/analytics/helpers.js'

export const PREPAYMENT_TOGGLE_MAP = {
  null: null,
  true: 'ON',
  false: 'OFF',
}

export const gtm1Appointment = {
  eventBusinessBookingActionHandler ({ data, country, routingConfig }) {
    const {
      screenName,
      eventAction,
      appointmentId = null,
      customerId = null,
      transactionId = null,
      userPosId = null,
      isBooksyUser = null,
      isPrepaymentSelected = null,
      isTrustedClient = null,
      isDepositToggle = null,
      isDepositRequired = null,
      depositAmount = null,
      businessAppointmentValue = null,
      isRetry = null,
      paymentInputAttempt = null,
      paymentMethod = null,
      resultScreen = null,
    } = data

    const customerIdPrefixed = getExternalId({ id: customerId, country, routingConfig })
    const transactionIdPrefixed = getExternalId({ id: transactionId, country, routingConfig })
    const userPosIdPrefixed = getExternalId({ id: userPosId, country, routingConfig })
    const appointmentIdPrefixed = getExternalId({ id: appointmentId, country, routingConfig })
    const customerType = isBooksyUser == null
      ? null
      : isBooksyUser ? 'booksy_user' : 'non-booksy_user'

    return {
      event: 'Business_Booking_Action',
      properties: {
        screen_name: screenName,
        event_action: eventAction,
        appointment_id: appointmentIdPrefixed,
        customer_id: customerIdPrefixed,
        transaction_id: transactionIdPrefixed,
        user_pos_id: userPosIdPrefixed,
        customer_type: customerType,
        prepayment_toggle: PREPAYMENT_TOGGLE_MAP[isPrepaymentSelected],
        trusted_client: isTrustedClient,
        deposit_toggle: isDepositToggle,
        require_deposit: isDepositRequired,
        deposit_amount: depositAmount,
        ba_value: businessAppointmentValue,
        is_retry: isRetry,
        payment_input_attempt: paymentInputAttempt,
        payment_method: paymentMethod,
        result_screen: resultScreen,
      },
    }
  },
}
